import { UniDriver } from '@wix/unidriver-core';
import { floatingNotificationDriverFactory as publicDriverFactory } from './FloatingNotification.uni.driver';

export const floatingNotificationPrivateDriverFactory = (base: UniDriver) => {
  return {
    ...publicDriverFactory(base),

    // Add here driver methods that considered "private"
  };
};
